import { FormInstance } from "antd/es/form";
import { Guid } from "guid-typescript";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IMasrafCesidi_List_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IMasrafCesidi_List_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  MasrafCesidiCount: any[];
  MasrafCesidiCount_dummy: any[];
  MasrafCesidiSelectAll: any[];
  MasrafCesidiSelectAll_dummy: any[];
  MasrafCesidiDeleteById: number;
  MasrafCesidiDeleteById_dummy: number;
}

export class MasrafCesidi_List_ScreenBase extends React.PureComponent<
  IMasrafCesidi_List_ScreenProps,
  any
> {
  masrafcesidi_list_399769_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "bd00ad4a-ed44-61e3-4813-27fcfc1bccc8",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "9f0b40ca-a5d3-4b72-bc52-230e83587430",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "29e74d32-80ec-4cc3-a265-86adf1a46154",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 923160, PropertyName: "value", Value: "Masraf Çeşidi Listesi" },
        { Id: 814413, PropertyName: "label", Value: "Ekle" },
        {
          Id: 399769,
          PropertyName: "nodatafoundmessage",
          Value: "No data found.",
        },
        { Id: 4736677, PropertyName: "title", Value: "Kod" },
        { Id: 8426839, PropertyName: "value", Value: "[datafield:kod]" },
        { Id: 2720125, PropertyName: "title", Value: "Ad" },
        { Id: 9453007, PropertyName: "value", Value: "[datafield:ad]" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.masrafcesidi_list_399769_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      MasrafCesidiCount: [],
      MasrafCesidiSelectAll: [],
      MasrafCesidiDeleteById: 0,
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("masrafcesidi_list", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.MasrafCesidi_ListPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("masrafcesidi_list", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("masrafcesidi_list", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.MasrafCesidi_ListPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  MasrafCesidi_ListPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MasrafCesidi_List/MasrafCesidi_ListPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.MasrafCesidiCount = result?.data.masrafCesidiCount;
    stateVars.MasrafCesidiSelectAll = result?.data.masrafCesidiSelectAll;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafCesidi_ListPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafCesidi_ListPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_399769 =
      stateVars.MasrafCesidiSelectAll ?? this.state.MasrafCesidiSelectAll;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  MasrafCesidi_ListComponent_981633_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "MasrafCesidi_List",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "139195",
      null,
      "left",
      "true",
      "450px",
      "",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MasrafCesidi_ListComponent_814413_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "MasrafCesidi_Form",
      "Id",
      ReactSystemFunctions.convertToTypeByName(Guid.create().toString(), "Guid")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "MasrafCesidi_List",
      "MasrafCesidi_Form",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "8602169",
      null,
      "right",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MasrafCesidi_ListComponent_860665_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "MasrafCesidi_Form",
      "Id",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "masrafcesidi_list_399769_value",
          "id"
        ),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "MasrafCesidi_List",
      "MasrafCesidi_Form",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "784897",
      null,
      null,
      "true",
      "800px",
      "70vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MasrafCesidi_ListComponent_505853_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "masrafcesidi_list_399769_value",
          "id"
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "fe852656_41cb_0d69_f310_feba936ad060_confirmation",
        this.defaultML,
        "Are you sure you want to delete this record?"
      ),
      "poppins",
      "",
      "",
      "#246dff"
    );

    if (stateVars.Confirm) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "MasrafCesidi_List/MasrafCesidi_ListComponent_505853_onClick",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.MasrafCesidiDeleteById = result?.data.masrafCesidiDeleteById;
      stateVars.MasrafCesidiCount = result?.data.masrafCesidiCount;
      stateVars.MasrafCesidiSelectAll = result?.data.masrafCesidiSelectAll;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.MasrafCesidi_ListComponent_505853_onClick1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafCesidi_ListComponent_505853_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_399769 =
      stateVars.MasrafCesidiSelectAll ?? this.state.MasrafCesidiSelectAll;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [8602169, 784897] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.MasrafCesidi_ListPageInit();
    }
  }
}
